"use client";

import type { Issue } from "../constants";
import {
	organizeIssuesBySection,
	sortIssuesByPriority,
	validateIssuesByState,
} from "../helpers";
import { RoadmapCard } from "./RoadmapCard";
import { RoadmapEmptyState } from "./RoadmapEmptyState";

type RoadmapListProps = {
	issues: Issue[];
	stateMappings: {
		planned: string[];
		inProgress: string[];
		completed: string[];
	};
};

export const RoadmapList = ({ issues, stateMappings }: RoadmapListProps) => {
	const validIssues = validateIssuesByState(issues, stateMappings);

	if (validIssues.length === 0) {
		return <RoadmapEmptyState />;
	}

	const organizedIssues = organizeIssuesBySection(validIssues, stateMappings);
	const allIssues = [
		...organizedIssues.completed.sort(sortIssuesByPriority),
		...organizedIssues.inProgress.sort(sortIssuesByPriority),
		...organizedIssues.planned.sort(sortIssuesByPriority),
	];

	return (
		<div className="grid gap-4">
			{allIssues.map((issue: Issue) => (
				<RoadmapCard key={issue.id} issue={issue} />
			))}
		</div>
	);
};
